export default [
  { 'name': 'Afghanistan', 'code': 'AF', 'phone_code': '+93', 'flag': '🇦🇫' },
  { 'name': 'Åland Islands', 'code': 'AX', 'phone_code': '+358', 'flag': '🇦🇽' },
  { 'name': 'Albania', 'code': 'AL', 'phone_code': '+355', 'flag': '🇦🇱' },
  { 'name': 'Algeria', 'code': 'DZ', 'phone_code': '+213', 'flag': '🇩🇿' },
  { 'name': 'American Samoa', 'code': 'AS', 'phone_code': '+1-684', 'flag': '🇦🇸' },
  { 'name': 'Andorra', 'code': 'AD', 'phone_code': '+376', 'flag': '🇦🇩' },
  { 'name': 'Angola', 'code': 'AO', 'phone_code': '+244', 'flag': '🇦🇴' },
  { 'name': 'Anguilla', 'code': 'AI', 'phone_code': '+1-264', 'flag': '🇦🇮' },
  { 'name': 'Antarctica', 'code': 'AQ', 'phone_code': '+672', 'flag': '🇦🇶' },
  { 'name': 'Antigua and Barbuda', 'code': 'AG', 'phone_code': '+1-268', 'flag': '🇦🇬' },
  { 'name': 'Argentina', 'code': 'AR', 'phone_code': '+54', 'flag': '🇦🇷' },
  { 'name': 'Armenia', 'code': 'AM', 'phone_code': '+374', 'flag': '🇦🇲' },
  { 'name': 'Aruba', 'code': 'AW', 'phone_code': '+297', 'flag': '🇦🇼' },
  { 'name': 'Australia', 'code': 'AU', 'phone_code': '+61', 'flag': '🇦🇺' },
  { 'name': 'Austria', 'code': 'AT', 'phone_code': '+43', 'flag': '🇦🇹' },
  { 'name': 'Azerbaijan', 'code': 'AZ', 'phone_code': '+994', 'flag': '🇦🇿' },
  { 'name': 'Bahamas', 'code': 'BS', 'phone_code': '+1-242', 'flag': '🇧🇸' },
  { 'name': 'Bahrain', 'code': 'BH', 'phone_code': '+973', 'flag': '🇧🇭' },
  { 'name': 'Bangladesh', 'code': 'BD', 'phone_code': '+880', 'flag': '🇧🇩' },
  { 'name': 'Barbados', 'code': 'BB', 'phone_code': '+1-246', 'flag': '🇧🇧' },
  { 'name': 'Belarus', 'code': 'BY', 'phone_code': '+375', 'flag': '🇧🇾' },
  { 'name': 'Belgium', 'code': 'BE', 'phone_code': '+32', 'flag': '🇧🇪' },
  { 'name': 'Belize', 'code': 'BZ', 'phone_code': '+501', 'flag': '🇧🇿' },
  { 'name': 'Benin', 'code': 'BJ', 'phone_code': '+229', 'flag': '🇧🇯' },
  { 'name': 'Bermuda', 'code': 'BM', 'phone_code': '+1-441', 'flag': '🇧🇲' },
  { 'name': 'Bhutan', 'code': 'BT', 'phone_code': '+975', 'flag': '🇧🇹' },
  { 'name': 'Bolivia', 'code': 'BO', 'phone_code': '+591', 'flag': '🇧🇴' },
  { 'name': 'Bosnia and Herzegovina', 'code': 'BA', 'phone_code': '+387', 'flag': '🇧🇦' },
  { 'name': 'Botswana', 'code': 'BW', 'phone_code': '+267', 'flag': '🇧🇼' },
  { 'name': 'Bouvet Island', 'code': 'BV', 'phone_code': '+47', 'flag': '🇧🇻' },
  { 'name': 'Brazil', 'code': 'BR', 'phone_code': '+55', 'flag': '🇧🇷' },
  { 'name': 'British Indian Ocean Territory', 'code': 'IO', 'phone_code': '+246', 'flag': '🇮🇴' },
  { 'name': 'Brunei Darussalam', 'code': 'BN', 'phone_code': '+673', 'flag': '🇧🇳' },
  { 'name': 'Bulgaria', 'code': 'BG', 'phone_code': '+359', 'flag': '🇧🇬' },
  { 'name': 'Burkina Faso', 'code': 'BF', 'phone_code': '+226', 'flag': '🇧🇫' },
  { 'name': 'Burundi', 'code': 'BI', 'phone_code': '+257', 'flag': '🇧🇮' },
  { 'name': 'Cambodia', 'code': 'KH', 'phone_code': '+855', 'flag': '🇰🇭' },
  { 'name': 'Cameroon', 'code': 'CM', 'phone_code': '+237', 'flag': '🇨🇲' },
  { 'name': 'Canada', 'code': 'CA', 'phone_code': '+1', 'flag': '🇨🇦' },
  { 'name': 'Cape Verde', 'code': 'CV', 'phone_code': '+238', 'flag': '🇨🇻' },
  { 'name': 'Cayman Islands', 'code': 'KY', 'phone_code': '+1-345', 'flag': '🇰🇾' },
  { 'name': 'Central African Republic', 'code': 'CF', 'phone_code': '+236', 'flag': '🇨🇫' },
  { 'name': 'Chad', 'code': 'TD', 'phone_code': '+235', 'flag': '🇹🇩' },
  { 'name': 'Chile', 'code': 'CL', 'phone_code': '+56', 'flag': '🇨🇱' },
  { 'name': 'China', 'code': 'CN', 'phone_code': '+86', 'flag': '🇨🇳' },
  { 'name': 'Christmas Island', 'code': 'CX', 'phone_code': '+61', 'flag': '🇨🇽' },
  { 'name': 'Cocos (Keeling) Islands', 'code': 'CC', 'phone_code': '+61', 'flag': '🇨🇨' },
  { 'name': 'Colombia', 'code': 'CO', 'phone_code': '+57', 'flag': '🇨🇴' },
  { 'name': 'Comoros', 'code': 'KM', 'phone_code': '+269', 'flag': '🇰🇲' },
  { 'name': 'Congo', 'code': 'CG', 'phone_code': '+242', 'flag': '🇨🇬' },
  { 'name': 'Congo, The Democratic Republic of the', 'code': 'CD', 'phone_code': '+243', 'flag': '🇨🇩' },
  { 'name': 'Cook Islands', 'code': 'CK', 'phone_code': '+682', 'flag': '🇨🇰' },
  { 'name': 'Costa Rica', 'code': 'CR', 'phone_code': '+506', 'flag': '🇨🇷' },
  { 'name': 'Cote D\'Ivoire', 'code': 'CI', 'phone_code': '+225', 'flag': '🇨🇮' },
  { 'name': 'Croatia', 'code': 'HR', 'phone_code': '+385', 'flag': '🇭🇷' },
  { 'name': 'Cuba', 'code': 'CU', 'phone_code': '+53', 'flag': '🇨🇺' },
  { 'name': 'Cyprus', 'code': 'CY', 'phone_code': '+357', 'flag': '🇨🇾' },
  { 'name': 'Czech Republic', 'code': 'CZ', 'phone_code': '+420', 'flag': '🇨🇿' },
  { 'name': 'Denmark', 'code': 'DK', 'phone_code': '+45', 'flag': '🇩🇰' },
  { 'name': 'Djibouti', 'code': 'DJ', 'phone_code': '+253', 'flag': '🇩🇯' },
  { 'name': 'Dominica', 'code': 'DM', 'phone_code': '+1-767', 'flag': '🇩🇲' },
  { 'name': 'Dominican Republic', 'code': 'DO', 'phone_code': '+1-809', 'flag': '🇩🇴' },
  { 'name': 'Ecuador', 'code': 'EC', 'phone_code': '+593', 'flag': '🇪🇨' },
  { 'name': 'Egypt', 'code': 'EG', 'phone_code': '+20', 'flag': '🇪🇬' },
  { 'name': 'El Salvador', 'code': 'SV', 'phone_code': '+503', 'flag': '🇸🇻' },
  { 'name': 'Equatorial Guinea', 'code': 'GQ', 'phone_code': '+240', 'flag': '🇬🇶' },
  { 'name': 'Eritrea', 'code': 'ER', 'phone_code': '+291', 'flag': '🇪🇷' },
  { 'name': 'Estonia', 'code': 'EE', 'phone_code': '+372', 'flag': '🇪🇪' },
  { 'name': 'Ethiopia', 'code': 'ET', 'phone_code': '+251', 'flag': '🇪🇹' },
  { 'name': 'Falkland Islands (Malvinas)', 'code': 'FK', 'phone_code': '+500', 'flag': '🇫🇰' },
  { 'name': 'Faroe Islands', 'code': 'FO', 'phone_code': '+298', 'flag': '🇫🇴' },
  { 'name': 'Fiji', 'code': 'FJ', 'phone_code': '+679', 'flag': '🇫🇯' },
  { 'name': 'Finland', 'code': 'FI', 'phone_code': '+358', 'flag': '🇫🇮' },
  { 'name': 'France', 'code': 'FR', 'phone_code': '+33', 'flag': '🇫🇷' },
  { 'name': 'French Guiana', 'code': 'GF', 'phone_code': '+594', 'flag': '🇬🇫' },
  { 'name': 'French Polynesia', 'code': 'PF', 'phone_code': '+689', 'flag': '🇵🇫' },
  { 'name': 'French Southern Territories', 'code': 'TF', 'phone_code': '+262', 'flag': '🇹🇫' },
  { 'name': 'Gabon', 'code': 'GA', 'phone_code': '+241', 'flag': '🇬🇦' },
  { 'name': 'Gambia', 'code': 'GM', 'phone_code': '+220', 'flag': '🇬🇲' },
  { 'name': 'Georgia', 'code': 'GE', 'phone_code': '+995', 'flag': '🇬🇪' },
  { 'name': 'Germany', 'code': 'DE', 'phone_code': '+49', 'flag': '🇩🇪' },
  { 'name': 'Ghana', 'code': 'GH', 'phone_code': '+233', 'flag': '🇬🇭' },
  { 'name': 'Gibraltar', 'code': 'GI', 'phone_code': '+350', 'flag': '🇬🇮' },
  { 'name': 'Greece', 'code': 'GR', 'phone_code': '+30', 'flag': '🇬🇷' },
  { 'name': 'Greenland', 'code': 'GL', 'phone_code': '+299', 'flag': '🇬🇱' },
  { 'name': 'Grenada', 'code': 'GD', 'phone_code': '+1-473', 'flag': '🇬🇩' },
  { 'name': 'Guadeloupe', 'code': 'GP', 'phone_code': '+590', 'flag': '🇬🇵' },
  { 'name': 'Guam', 'code': 'GU', 'phone_code': '+1-671', 'flag': '🇬🇺' },
  { 'name': 'Guatemala', 'code': 'GT', 'phone_code': '+502', 'flag': '🇬🇹' },
  { 'name': 'Guernsey', 'code': 'GG', 'phone_code': '+44', 'flag': '🇬🇬' },
  { 'name': 'Guinea', 'code': 'GN', 'phone_code': '+224', 'flag': '🇬🇳' },
  { 'name': 'Guinea-Bissau', 'code': 'GW', 'phone_code': '+245', 'flag': '🇬🇼' },
  { 'name': 'Guyana', 'code': 'GY', 'phone_code': '+592', 'flag': '🇬🇾' },
  { 'name': 'Haiti', 'code': 'HT', 'phone_code': '+509', 'flag': '🇭🇹' },
  { 'name': 'Heard Island and McDonald Islands', 'code': 'HM', 'phone_code': '+672', 'flag': '🇭🇲' },
  { 'name': 'Holy See (Vatican City State)', 'code': 'VA', 'phone_code': '+39', 'flag': '🇻🇦' },
  { 'name': 'Honduras', 'code': 'HN', 'phone_code': '+504', 'flag': '🇭🇳' },
  { 'name': 'Hong Kong', 'code': 'HK', 'phone_code': '+852', 'flag': '🇭🇰' },
  { 'name': 'Hungary', 'code': 'HU', 'phone_code': '+36', 'flag': '🇭🇺' },
  { 'name': 'Iceland', 'code': 'IS', 'phone_code': '+354', 'flag': '🇮🇸' },
  { 'name': 'India', 'code': 'IN', 'phone_code': '+91', 'flag': '🇮🇳' },
  { 'name': 'Indonesia', 'code': 'ID', 'phone_code': '+62', 'flag': '🇮🇩' },
  { 'name': 'Iran, Islamic Republic of', 'code': 'IR', 'phone_code': '+98', 'flag': '🇮🇷' },
  { 'name': 'Iraq', 'code': 'IQ', 'phone_code': '+964', 'flag': '🇮🇶' },
  { 'name': 'Ireland', 'code': 'IE', 'phone_code': '+353', 'flag': '🇮🇪' },
  { 'name': 'Isle of Man', 'code': 'IM', 'phone_code': '+44', 'flag': '🇮🇲' },
  { 'name': 'Israel', 'code': 'IL', 'phone_code': '+972', 'flag': '🇮🇱' },
  { 'name': 'Italy', 'code': 'IT', 'phone_code': '+39', 'flag': '🇮🇹' },
  { 'name': 'Jamaica', 'code': 'JM', 'phone_code': '+1-876', 'flag': '🇯🇲' },
  { 'name': 'Japan', 'code': 'JP', 'phone_code': '+81', 'flag': '🇯🇵' },
  { 'name': 'Jersey', 'code': 'JE', 'phone_code': '+44', 'flag': '🇯🇪' },
  { 'name': 'Jordan', 'code': 'JO', 'phone_code': '+962', 'flag': '🇯🇴' },
  { 'name': 'Kazakhstan', 'code': 'KZ', 'phone_code': '+7', 'flag': '🇰🇿' },
  { 'name': 'Kenya', 'code': 'KE', 'phone_code': '+254', 'flag': '🇰🇪' },
  { 'name': 'Kiribati', 'code': 'KI', 'phone_code': '+686', 'flag': '🇰🇮' },
  { 'name': 'Korea, Democratic People\'s Republic of', 'code': 'KP', 'phone_code': '+850', 'flag': '🇰🇵' },
  { 'name': 'Korea, Republic of', 'code': 'KR', 'phone_code': '+82', 'flag': '🇰🇷' },
  { 'name': 'Kuwait', 'code': 'KW', 'phone_code': '+965', 'flag': '🇰🇼' },
  { 'name': 'Kyrgyzstan', 'code': 'KG', 'phone_code': '+996', 'flag': '🇰🇬' },
  { 'name': 'Lao People\'s Democratic Republic', 'code': 'LA', 'phone_code': '+856', 'flag': '🇱🇦' },
  { 'name': 'Latvia', 'code': 'LV', 'phone_code': '+371', 'flag': '🇱🇻' },
  { 'name': 'Lebanon', 'code': 'LB', 'phone_code': '+961', 'flag': '🇱🇧' },
  { 'name': 'Lesotho', 'code': 'LS', 'phone_code': '+266', 'flag': '🇱🇸' },
  { 'name': 'Liberia', 'code': 'LR', 'phone_code': '+231', 'flag': '🇱🇷' },
  { 'name': 'Libya', 'code': 'LY', 'phone_code': '+218', 'flag': '🇱🇾' },
  { 'name': 'Liechtenstein', 'code': 'LI', 'phone_code': '+423', 'flag': '🇱🇮' },
  { 'name': 'Lithuania', 'code': 'LT', 'phone_code': '+370', 'flag': '🇱🇹' },
  { 'name': 'Luxembourg', 'code': 'LU', 'phone_code': '+352', 'flag': '🇱🇺' },
  { 'name': 'Macao', 'code': 'MO', 'phone_code': '+853', 'flag': '🇲🇴' },
  { 'name': 'Macedonia, The Former Yugoslav Republic of', 'code': 'MK', 'phone_code': '+389', 'flag': '🇲🇰' },
  { 'name': 'Madagascar', 'code': 'MG', 'phone_code': '+261', 'flag': '🇲🇬' },
  { 'name': 'Malawi', 'code': 'MW', 'phone_code': '+265', 'flag': '🇲🇼' },
  { 'name': 'Malaysia', 'code': 'MY', 'phone_code': '+60', 'flag': '🇲🇾' },
  { 'name': 'Maldives', 'code': 'MV', 'phone_code': '+960', 'flag': '🇲🇻' },
  { 'name': 'Mali', 'code': 'ML', 'phone_code': '+223', 'flag': '🇲🇱' },
  { 'name': 'Malta', 'code': 'MT', 'phone_code': '+356', 'flag': '🇲🇹' },
  { 'name': 'Marshall Islands', 'code': 'MH', 'phone_code': '+692', 'flag': '🇲🇭' },
  { 'name': 'Martinique', 'code': 'MQ', 'phone_code': '+596', 'flag': '🇲🇶' },
  { 'name': 'Mauritania', 'code': 'MR', 'phone_code': '+222', 'flag': '🇲🇷' },
  { 'name': 'Mauritius', 'code': 'MU', 'phone_code': '+230', 'flag': '🇲🇺' },
  { 'name': 'Mayotte', 'code': 'YT', 'phone_code': '+262', 'flag': '🇾🇹' },
  { 'name': 'Mexico', 'code': 'MX', 'phone_code': '+52', 'flag': '🇲🇽' },
  { 'name': 'Micronesia, Federated States of', 'code': 'FM', 'phone_code': '+691', 'flag': '🇫🇲' },
  { 'name': 'Moldova, Republic of', 'code': 'MD', 'phone_code': '+373', 'flag': '🇲🇩' },
  { 'name': 'Monaco', 'code': 'MC', 'phone_code': '+377', 'flag': '🇲🇨' },
  { 'name': 'Mongolia', 'code': 'MN', 'phone_code': '+976', 'flag': '🇲🇳' },
  { 'name': 'Montserrat', 'code': 'MS', 'phone_code': '+1-664', 'flag': '🇲🇸' },
  { 'name': 'Morocco', 'code': 'MA', 'phone_code': '+212', 'flag': '🇲🇦' },
  { 'name': 'Mozambique', 'code': 'MZ', 'phone_code': '+258', 'flag': '🇲🇿' },
  { 'name': 'Myanmar', 'code': 'MM', 'phone_code': '+95', 'flag': '🇲🇲' },
  { 'name': 'Namibia', 'code': 'NA', 'phone_code': '+264', 'flag': '🇳🇦' },
  { 'name': 'Nauru', 'code': 'NR', 'phone_code': '+674', 'flag': '🇳🇷' },
  { 'name': 'Nepal', 'code': 'NP', 'phone_code': '+977', 'flag': '🇳🇵' },
  { 'name': 'Netherlands', 'code': 'NL', 'phone_code': '+31', 'flag': '🇳🇱' },
  { 'name': 'Netherlands Antilles', 'code': 'AN', 'phone_code': '+599', 'flag': '🇦🇳' },
  { 'name': 'New Caledonia', 'code': 'NC', 'phone_code': '+687', 'flag': '🇳🇨' },
  { 'name': 'New Zealand', 'code': 'NZ', 'phone_code': '+64', 'flag': '🇳🇿' },
  { 'name': 'Nicaragua', 'code': 'NI', 'phone_code': '+505', 'flag': '🇳🇮' },
  { 'name': 'Niger', 'code': 'NE', 'phone_code': '+227', 'flag': '🇳🇪' },
  { 'name': 'Nigeria', 'code': 'NG', 'phone_code': '+234', 'flag': '🇳🇬' },
  { 'name': 'Niue', 'code': 'NU', 'phone_code': '+683', 'flag': '🇳🇺' },
  { 'name': 'Norfolk Island', 'code': 'NF', 'phone_code': '+672', 'flag': '🇳🇫' },
  { 'name': 'Northern Mariana Islands', 'code': 'MP', 'phone_code': '+1-670', 'flag': '🇲🇵' },
  { 'name': 'Norway', 'code': 'NO', 'phone_code': '+47', 'flag': '🇳🇴' },
  { 'name': 'Oman', 'code': 'OM', 'phone_code': '+968', 'flag': '🇴🇲' },
  { 'name': 'Pakistan', 'code': 'PK', 'phone_code': '+92', 'flag': '🇵🇰' },
  { 'name': 'Palau', 'code': 'PW', 'phone_code': '+680', 'flag': '🇵🇼' },
  { 'name': 'Palestinian Territory, Occupied', 'code': 'PS', 'phone_code': '+970', 'flag': '🇵🇸' },
  { 'name': 'Panama', 'code': 'PA', 'phone_code': '+507', 'flag': '🇵🇦' },
  { 'name': 'Papua New Guinea', 'code': 'PG', 'phone_code': '+675', 'flag': '🇵🇬' },
  { 'name': 'Paraguay', 'code': 'PY', 'phone_code': '+595', 'flag': '🇵🇾' },
  { 'name': 'Peru', 'code': 'PE', 'phone_code': '+51', 'flag': '🇵🇪' },
  { 'name': 'Philippines', 'code': 'PH', 'phone_code': '+63', 'flag': '🇵🇭' },
  { 'name': 'Pitcairn', 'code': 'PN', 'phone_code': '+64', 'flag': '🇵🇳' },
  { 'name': 'Poland', 'code': 'PL', 'phone_code': '+48', 'flag': '🇵🇱' },
  { 'name': 'Portugal', 'code': 'PT', 'phone_code': '+351', 'flag': '🇵🇹' },
  { 'name': 'Puerto Rico', 'code': 'PR', 'phone_code': '+1-787', 'flag': '🇵🇷' },
  { 'name': 'Qatar', 'code': 'QA', 'phone_code': '+974', 'flag': '🇶🇦' },
  { 'name': 'Reunion', 'code': 'RE', 'phone_code': '+262', 'flag': '🇷🇪' },
  { 'name': 'Romania', 'code': 'RO', 'phone_code': '+40', 'flag': '🇷🇴' },
  { 'name': 'Russian Federation', 'code': 'RU', 'phone_code': '+7', 'flag': '🇷🇺' },
  { 'name': 'Rwanda', 'code': 'RW', 'phone_code': '+250', 'flag': '🇷🇼' },
  { 'name': 'Saint Helena', 'code': 'SH', 'phone_code': '+290', 'flag': '🇸🇭' },
  { 'name': 'Saint Kitts and Nevis', 'code': 'KN', 'phone_code': '+1-869', 'flag': '🇰🇳' },
  { 'name': 'Saint Lucia', 'code': 'LC', 'phone_code': '+1-758', 'flag': '🇱🇨' },
  { 'name': 'Saint Pierre and Miquelon', 'code': 'PM', 'phone_code': '+508', 'flag': '🇵🇲' },
  { 'name': 'Saint Vincent and the Grenadines', 'code': 'VC', 'phone_code': '+1-784', 'flag': '🇻🇨' },
  { 'name': 'Samoa', 'code': 'WS', 'phone_code': '+685', 'flag': '🇼🇸' },
  { 'name': 'San Marino', 'code': 'SM', 'phone_code': '+378', 'flag': '🇸🇲' },
  { 'name': 'Sao Tome and Principe', 'code': 'ST', 'phone_code': '+239', 'flag': '🇸🇹' },
  { 'name': 'Saudi Arabia', 'code': 'SA', 'phone_code': '+966', 'flag': '🇸🇦' },
  { 'name': 'Senegal', 'code': 'SN', 'phone_code': '+221', 'flag': '🇸🇳' },
  { 'name': 'Serbia', 'code': 'RS', 'phone_code': '+381', 'flag': '🇷🇸' },
  { 'name': 'Montenegro', 'code': 'ME', 'phone_code': '+382', 'flag': '🇲🇪' },
  { 'name': 'Seychelles', 'code': 'SC', 'phone_code': '+248', 'flag': '🇸🇨' },
  { 'name': 'Sierra Leone', 'code': 'SL', 'phone_code': '+232', 'flag': '🇸🇱' },
  { 'name': 'Singapore', 'code': 'SG', 'phone_code': '+65', 'flag': '🇸🇬' },
  { 'name': 'Slovakia', 'code': 'SK', 'phone_code': '+421', 'flag': '🇸🇰' },
  { 'name': 'Slovenia', 'code': 'SI', 'phone_code': '+386', 'flag': '🇸🇮' },
  { 'name': 'Solomon Islands', 'code': 'SB', 'phone_code': '+677', 'flag': '🇸🇧' },
  { 'name': 'Somalia', 'code': 'SO', 'phone_code': '+252', 'flag': '🇸🇴' },
  { 'name': 'South Africa', 'code': 'ZA', 'phone_code': '+27', 'flag': '🇿🇦' },
  { 'name': 'South Georgia and the South Sandwich Islands', 'code': 'GS', 'phone_code': '+500', 'flag': '🇬🇸' },
  { 'name': 'Spain', 'code': 'ES', 'phone_code': '+34', 'flag': '🇪🇸' },
  { 'name': 'Sri Lanka', 'code': 'LK', 'phone_code': '+94', 'flag': '🇱🇰' },
  { 'name': 'Sudan', 'code': 'SD', 'phone_code': '+249', 'flag': '🇸🇩' },
  { 'name': 'Suriname', 'code': 'SR', 'phone_code': '+597', 'flag': '🇸🇷' },
  { 'name': 'Svalbard and Jan Mayen', 'code': 'SJ', 'phone_code': '+47', 'flag': '🇸🇯' },
  { 'name': 'Swaziland', 'code': 'SZ', 'phone_code': '+268', 'flag': '🇸🇿' },
  { 'name': 'Sweden', 'code': 'SE', 'phone_code': '+46', 'flag': '🇸🇪' },
  { 'name': 'Switzerland', 'code': 'CH', 'phone_code': '+41', 'flag': '🇨🇭' },
  { 'name': 'Syrian Arab Republic', 'code': 'SY', 'phone_code': '+963', 'flag': '🇸🇾' },
  { 'name': 'Taiwan, Province of China', 'code': 'TW', 'phone_code': '+886', 'flag': '🇹🇼' },
  { 'name': 'Tajikistan', 'code': 'TJ', 'phone_code': '+992', 'flag': '🇹🇯' },
  { 'name': 'Tanzania, United Republic of', 'code': 'TZ', 'phone_code': '+255', 'flag': '🇹🇿' },
  { 'name': 'Thailand', 'code': 'TH', 'phone_code': '+66', 'flag': '🇹🇭' },
  { 'name': 'Timor-Leste', 'code': 'TL', 'phone_code': '+670', 'flag': '🇹🇱' },
  { 'name': 'Togo', 'code': 'TG', 'phone_code': '+228', 'flag': '🇹🇬' },
  { 'name': 'Tokelau', 'code': 'TK', 'phone_code': '+690', 'flag': '🇹🇰' },
  { 'name': 'Tonga', 'code': 'TO', 'phone_code': '+676', 'flag': '🇹🇴' },
  { 'name': 'Trinidad and Tobago', 'code': 'TT', 'phone_code': '+1-868', 'flag': '🇹🇹' },
  { 'name': 'Tunisia', 'code': 'TN', 'phone_code': '+216', 'flag': '🇹🇳' },
  { 'name': 'Turkey', 'code': 'TR', 'phone_code': '+90', 'flag': '🇹🇷' },
  { 'name': 'Turkmenistan', 'code': 'TM', 'phone_code': '+993', 'flag': '🇹🇲' },
  { 'name': 'Turks and Caicos Islands', 'code': 'TC', 'phone_code': '+1-649', 'flag': '🇹🇨' },
  { 'name': 'Tuvalu', 'code': 'TV', 'phone_code': '+688', 'flag': '🇹🇻' },
  { 'name': 'Uganda', 'code': 'UG', 'phone_code': '+256', 'flag': '🇺🇬' },
  { 'name': 'Ukraine', 'code': 'UA', 'phone_code': '+380', 'flag': '🇺🇦' },
  { 'name': 'United Arab Emirates', 'code': 'AE', 'phone_code': '+971', 'flag': '🇦🇪' },
  { 'name': 'United Kingdom', 'code': 'GB', 'phone_code': '+44', 'flag': '🇬🇧' },
  { 'name': 'United States', 'code': 'US', 'phone_code': '+1', 'flag': '🇺🇸' },
  { 'name': 'United States Minor Outlying Islands', 'code': 'UM', 'phone_code': '+1', 'flag': '🇺🇲' },
  { 'name': 'Uruguay', 'code': 'UY', 'phone_code': '+598', 'flag': '🇺🇾' },
  { 'name': 'Uzbekistan', 'code': 'UZ', 'phone_code': '+998', 'flag': '🇺🇿' },
  { 'name': 'Vanuatu', 'code': 'VU', 'phone_code': '+678', 'flag': '🇻🇺' },
  { 'name': 'Venezuela', 'code': 'VE', 'phone_code': '+58', 'flag': '🇻🇪' },
  { 'name': 'Viet Nam', 'code': 'VN', 'phone_code': '+84', 'flag': '🇻🇳' },
  { 'name': 'Virgin Islands, British', 'code': 'VG', 'phone_code': '+1-284', 'flag': '🇻🇬' },
  { 'name': 'Virgin Islands, U.S.', 'code': 'VI', 'phone_code': '+1-340', 'flag': '🇻🇮' },
  { 'name': 'Wallis and Futuna', 'code': 'WF', 'phone_code': '+681', 'flag': '🇼🇫' },
  { 'name': 'Western Sahara', 'code': 'EH', 'phone_code': '+212', 'flag': '🇪🇭' },
  { 'name': 'Yemen', 'code': 'YE', 'phone_code': '+967', 'flag': '🇾🇪' },
  { 'name': 'Zambia', 'code': 'ZM', 'phone_code': '+260', 'flag': '🇿🇲' },
  { 'name': 'Zimbabwe', 'code': 'ZW', 'phone_code': '+263', 'flag': '🇿🇼' },
];